/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { useIsAccessAllow } from "../../../../../app/modules/users/redux";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

  const isUserListAllow = useIsAccessAllow("user.list");
  const isColdLeadsAllow = useIsAccessAllow("candidatemaster.list");
  const isSettingsAllow = useIsAccessAllow("settings.*");
  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li className={`menu-item ${getMenuItemActive("/dashboard", false)}`}>
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>

        {isUserListAllow && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/user-management",
              true
            ) ||
              getMenuItemActive("/user", true) ||
              getMenuItemActive("/role", true)}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/user">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Contact1.svg"
                  )}
                />
              </span>
              <span className="menu-text">User Management</span>
              <i className="menu-arrow" />
            </NavLink>

            <div className="menu-submenu ">
              <ul className="menu-subnav">
                {isUserListAllow && (
                  <li
                    className={`menu-item ${getMenuItemActive("/user", false)}`}
                  >
                    <NavLink className="menu-link" to="/user">
                      <span className="svg-icon menu-icon">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Communication/Group.svg"
                          )}
                        />
                      </span>
                      <span className="menu-text">Users</span>
                    </NavLink>
                  </li>
                )}

                {/* <li className={`menu-item ${getMenuItemActive("/role", false)}`}>
                <NavLink className="menu-link" to="/role">
                  <span className="svg-icon menu-icon">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Communication/Contact1.svg"
                      )}
                    />
                  </span>
                  <span className="menu-text">Role</span>
                </NavLink>
              </li> */}
              </ul>
            </div>
          </li>
        )}

        {isColdLeadsAllow && (
          <li
            className={`menu-item ${getMenuItemActive("/candidates-master", false)}`}
          >
            <NavLink className="menu-link" to="/candidates-master">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Contact1.svg"
                  )}
                />
              </span>
              <span className="menu-text">Candidates Master</span>
            </NavLink>
          </li>
        )}

        {/* Settings */}
        {isSettingsAllow && (
          <li className={`menu-item ${getMenuItemActive("/settings", false)}`}>
            <NavLink className="menu-link" to="/settings">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/General/Settings-2.svg"
                  )}
                />
              </span>
              <span className="menu-text">Settings</span>
            </NavLink>
          </li>
        )}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
